import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { palette } from 'styled-theme';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const getSize = ({ size }) => `${size}em`;
const getBorderSize = ({ size }) => `${size / 8}em`;

const Spinner = styled.div`
  position: relative;
  /*border: ${getBorderSize} solid ${palette('grayscale', 1, true)};*/
  border: ${getBorderSize} solid #d1e0f0;
  border-bottom-color: #004a93;
  border-radius: 50%;
  margin: 0 auto;
  width: ${getSize};
  height: ${getSize};
  animation: ${spin} 1s linear infinite;
`;

Spinner.propTypes = {
  palette: PropTypes.string,
  reverse: PropTypes.bool,
  size: PropTypes.number,
};

Spinner.defaultProps = {
  palette: 'primary',
  size: 1,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/shared-components/atoms/Spinner/index.js